import React, { useState } from "react";
import MDBox from "components/MDBox";
import ConsultSolicitacoes from "./ConsultSolicitacoes";
import CreateSolicitacao from "./CreateSolicitacao";

export default function SolicitacoesSystem() {
    const [view, setView] = useState("CONSULT"); // 'CONSULT' ou 'CREATE'
    const [selectedEntity, setSelectedEntity] = useState(null);
    const [isCreatorView, setIsCreatorView] = useState(false);

    return (
        <React.Fragment>
            <MDBox display={view === "CONSULT" ? "block" : "none"}>
                <ConsultSolicitacoes 
                    onNewClick={() => { setSelectedEntity(null); setIsCreatorView(false); setView("CREATE"); }} 
                    onEditClick={(solicitacao, filterOpt) => { setSelectedEntity(solicitacao); setIsCreatorView(filterOpt === 'CRIADO_POR_MIM'); setView("CREATE"); }}
                />
            </MDBox>
            {view === "CREATE" && <CreateSolicitacao isCreatorView={isCreatorView} solicitacaoBase={selectedEntity} onGoBack={() => setView("CONSULT")} />}
        </React.Fragment>
    );
}
